import React from "react";
import { Input } from "../Input/Input";

const VendorsCollaborators = ({ handleChange, sectionStyles, formData, errors }) => {
  // List of vendors
  const vendors = [
    { label: "Photography", name: "vendorPhotography" },
    { label: "Videography", name: "vendorVideography" },
    { label: "Bridal hair & makeup / guests' hair and makeup", name: "vendorHairMakeup" },
    { label: "Wedding cake", name: "vendorWeddingCake" },
    { label: "Musicians", name: "vendorMusicians" },
    { label: "Entertainment (DJ, Dancers)", name: "vendorEntertainment" },
    { label: "Catering service", name: "vendorCatering" },
    { label: "Transportation for guests", name: "vendorGuestTransport" },
    { label: "Transportation for the wedding couple", name: "vendorCoupleTransport" },
    { label: "Fireworks", name: "vendorFireworks" },
    { label: "Boat / Catamaran tours", name: "vendorBoatTours" },
    { label: "Photo tours", name: "vendorPhotoTours" },
    { label: "Equipment rental (chairs, tables, art de la table, furniture)", name: "vendorEquipmentRental" },
    { label: "Decor equipment rental (Chandeliers, gazebos, podiums, decorative constructions...)", name: "vendorDecorRental" },
    { label: "Vintage cars", name: "vendorVintageCars" },
  ];

  return (
    <section className="p-3 lg:p-5 mb-8 lg:mb-6">
      <h3 className="text-2xl font-semibold mb-4 text-left">
        the <span className="uppercase">Vendors</span> & collaborators
      </h3>

      <p className="text-lg mb-4">
        Are there vendors you'd like us to recommend for you?
      </p>

      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              <th className="text-left p-2 border border-gray-300">Description</th>
              <th className="text-left p-2 border border-gray-300">Check</th>
            </tr>
          </thead>
          <tbody>
            {vendors.map((vendor) => (
              <tr key={vendor.name}>
                <td className="p-2 border border-gray-300">{vendor.label}</td>
                <td className="p-2 border border-gray-300">
                  <Input
                    type="checkbox"
                    name="vendorsAndCollaborators"
                    value={vendor.label}
                    handleChange={handleChange}
                    sectionStyles={sectionStyles.label}
                    className={sectionStyles.checkbox}
                    checked={
                      formData.vendorsAndCollaborators &&
                      formData.vendorsAndCollaborators.split(", ").includes(vendor.label)
                    }
                  />
                </td>
              </tr>
              
            ))}
          </tbody>
        </table>
        {/* { errors.vendorsAndCollaborators && (
          <p className="text-red-500 text-sm">{errors.vendorsAndCollaborators}</p>
        )} */}
      </div>
    </section>
  );
};

export default VendorsCollaborators;
